// extracted by mini-css-extract-plugin
module.exports = {"component":"RestaurantList_component__1G1Zt","item":"RestaurantList_item__3smjP","title":"RestaurantList_title__cC8ob"};